import { REGULAR_DETALIZATION_REPORT_ACTIONS } from './constants';

export const regularDetalizationReportInitialState = {
  isFetching: false,
  isError: false,
  numbers: [],
  subscriptionStatus: null,
  startSubscriptionDate: null,
  dueSubscriptionDate: null,
  reportType: null,

  isUpdating: false,
  isUpdatingSuccess: false,
  isUpdatingError: false,
};

const regularDetalizationReport = (state = regularDetalizationReportInitialState, action) => {
  switch (action.type) {
    // FETCH DATA
    case REGULAR_DETALIZATION_REPORT_ACTIONS.FETCH_REGULAR_DETALIZATION_REPORT_DATA:
      return {
        ...state,
        isFetching: true,
        isError: false,
      };
    case REGULAR_DETALIZATION_REPORT_ACTIONS.FETCH_REGULAR_DETALIZATION_REPORT_DATA_SUCCESS: {
      const {
        numbers,
        subscriptionStatus,
        reportType,
        startSubscriptionDate,
        dueSubscriptionDate,
      } = action.payload;

      return {
        ...state,
        isFetching: false,
        isError: false,
        numbers,
        subscriptionStatus,
        reportType,
        startSubscriptionDate,
        dueSubscriptionDate,
      };
    }
    case REGULAR_DETALIZATION_REPORT_ACTIONS.FETCH_REGULAR_DETALIZATION_REPORT_DATA_ERROR:
      return {
        ...state,
        isFetching: false,
        isError: true,
      };
    // SAVE DATA
    case REGULAR_DETALIZATION_REPORT_ACTIONS.SAVE_REGULAR_DETALIZATION_REPORT_DATA:
      return {
        ...state,
        isUpdating: true,
        isUpdatingError: false,
      };
    case REGULAR_DETALIZATION_REPORT_ACTIONS.SAVE_REGULAR_DETALIZATION_REPORT_DATA_SUCCESS: {
      const {
        subscriptionStatus,
        startSubscriptionDate,
        numbers,
        reportType,
      } = action.payload;

      return {
        ...state,
        subscriptionStatus,
        startSubscriptionDate,
        numbers,
        reportType,
        isUpdating: false,
        isUpdatingSuccess: true,
      };
    }
    case REGULAR_DETALIZATION_REPORT_ACTIONS.SAVE_REGULAR_DETALIZATION_REPORT_DATA_ERROR:
      return {
        ...state,
        isUpdating: false,
        isUpdatingError: true,
      };
    case REGULAR_DETALIZATION_REPORT_ACTIONS.SET_SAVE_REGULAR_DETALIZATION_REPORT_INITIAL_CONTROLS_DATA:
      return {
        ...state,
        isUpdating: false,
        isUpdatingError: false,
        isUpdatingSuccess: false,
      };
    default:
      return state;
  }
};

export default regularDetalizationReport;
